export default {
    'username': 'Username',
    'password': 'Password',
    'sign-in': 'Sign in',
    'select-financial-file': 'Select financial file',
    'show-financial-file': 'Show financial file',
}